import { createAction } from 'redux-actions'

export const Set_Bot_Settings_Info = 'set bot settings info'

export const Delete_Bot_Settings_Info = 'delete bot settings info'

export const setBotSettingsInfo = createAction(Set_Bot_Settings_Info)
export const deleteBotSettingsInfo = createAction(Delete_Bot_Settings_Info)
